import Choices from 'choices.js'

export default (el) => {
  // eslint-disable-next-line no-new
  new Choices(el, {
    searchChoices: true,
    classNames: {
      containerInner: el.classList.toString(),
      containerOuter: 'choices mb-0'
    }
  })
}
